import React from 'react';
import { Container } from './styles';

export default function DivDiagonal({
    children,
    isDiagonal,
    shortMobileGradient = false,
    mobileHeight = null,
}) {
    return (
        <Container
            isDiagonal={isDiagonal}
            $shortMobileGradient={shortMobileGradient}
            $mobileHeight={mobileHeight}
            className="p-0"
        >
            {children}
        </Container>
    );
}
